/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import SvgArrow from '../Svg/SvgArrow';
import SvgSliderDot from '../Svg/SvgSliderDot';
import Animation from '../../helpers/animation';
import { getActiveSlides, getLeftBanner, getSocialLinks } from './requests';
import './index.css';

function MainSlider({ notRender }) {
  const [openLeftBanner, setOpenLeftBanner] = useState(false);
  const buttonRef = useRef(null);
  // const [openRightBanner, setOpenRightBanner] = useState(false);
  // const [socialLinks, setSocialLinks] = useState([]);
  const heightBannerLinkContainer = 212;
  const heightBannerLink = 70;
  const visibliLinks = 3;
  const defaultPercentageReduction = 1;
  const { innerWidth } = window;
  const defaultContentWidth = 1398;
  const defaultBannerControlWidth = 46;
  const scrollBarWidth = 16;
  const maxWidthBanner = 258;

  const [buttonData, setButtonData] = useState({});
  const [slides, setSlides] = useState(null);
  const widthOnePoint = 30;
  const dotsLength = slides ? slides.length * widthOnePoint : 0;

  async function processingRequest() {
    setSlides((await getActiveSlides()).data);
    // setSocialLinks((await getSocialLinks()).data);
    if (innerWidth < 1200) 
      setButtonData((await getLeftBanner()).data);
  }
  useEffect(() => {
    processingRequest();
  }, []);
  // const heightOpenBannerLinks = heightBannerLinkContainer
    // + heightBannerLink * (socialLinks.length - visibliLinks);

  const getcontentWidth = () => {
    if (innerWidth < 1900 && innerWidth > 1600) {
      return (defaultContentWidth * 90) / 100;
    }
    if (innerWidth < 1600 && innerWidth > 1400) {
      return (defaultContentWidth * 80) / 100;
    }
    if (innerWidth < 1400 && innerWidth > 1200) {
      return (defaultContentWidth * 70) / 100;
    }
    return defaultContentWidth;
  };

  const getBannerControlWidth = () => {
    if (innerWidth < 1900 && innerWidth > 1600) {
      return (defaultBannerControlWidth * 90) / 100;
    }
    if (innerWidth < 1600 && innerWidth > 1400) {
      return (defaultBannerControlWidth * 80) / 100;
    }
    if (innerWidth < 1400 && innerWidth > 1200) {
      return (defaultBannerControlWidth * 70) / 100;
    }
    return defaultBannerControlWidth;
  };

  const getPercentageReduction = () => {
    if (innerWidth < 1900 && innerWidth > 1600) {
      return (defaultPercentageReduction * 90) / 100;
    }
    if (innerWidth < 1600 && innerWidth > 1400) {
      return (defaultPercentageReduction * 80) / 100;
    }
    if (innerWidth < 1400 && innerWidth > 1200) {
      return (defaultPercentageReduction * 70) / 100;
    }
    return defaultPercentageReduction;
  };
  const percentageReduction = getPercentageReduction();
  const contentWidth = getcontentWidth();
  const bannerControlWidth = getBannerControlWidth();

  const freeWidth = (innerWidth - contentWidth - scrollBarWidth) / 2 - bannerControlWidth;
  const bannerWidth = freeWidth / percentageReduction > maxWidthBanner
    ? maxWidthBanner
    : freeWidth / percentageReduction;
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="slick-arrow slick-next"
        onClick={(e) => {
          new Animation(e).button();
          onClick();
        }}
      >
        <SvgArrow color="yellow" direction="right" size={25} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="slick-arrow slick-prev"
        onClick={(e) => {
          new Animation(e).button();
          onClick();
        }}
        style={{ right: 50 + dotsLength }}
      >
        <SvgArrow color="yellow" direction="left" size={25} />
      </div>
    );
  }
  SampleNextArrow.propTypes = {
    onClick: PropTypes.func,
  };

  SampleNextArrow.defaultProps = {
    onClick: () => {},
  };

  SamplePrevArrow.propTypes = {
    onClick: PropTypes.func,
  };

  SamplePrevArrow.defaultProps = {
    onClick: () => {},
  };
  // console.log("slides: ", slides);
  return (
    <>
      <div className="announcements-container">
        {(!notRender && slides) && (
          <div className="announcements-slider main-slider">
            {/* <CarouselWidget data={slides} /> */}
            <Slider
              autoplay
              dots
              customPaging={() => (
                <button type="button">
                  <SvgSliderDot />
                </button>
              )}
              infinite
              centerMode={false}
              speed={600}
              autoplaySpeed={3000}
              pauseOnHover
              slidesToShow={1}
              slidesToScroll={1}
              nextArrow={<SampleNextArrow />}
              prevArrow={<SamplePrevArrow />}
            >
              {slides.map((item, index) => (
                // <NavLink to={`/news/${item.link}`} key={index.toString()}>
                <a className="slider-link" href={item.link} key={index.toString()} target={item.link[0] === '/' ? null : '_blank'} rel="noreferrer">
                  {/* <div className="slide-item" style = {{backgroundImage: `url(${item.picture.replace(" ", "%20")})`, backgroundPosition: 'center'}}> */}
                    {item.picture && (
                      <img
                      src={item.picture.replace(" ", "%20")}
                      alt={item.title}
                      className="slider-img"
                    />
                    )}
                  {/* </div> */}
                </a>
              ))}
            </Slider>
          </div>
        )}
      </div>
      {(innerWidth < 1200 && buttonData.active) && (
        <>
          {/* <a className="slide-banner-button" href={buttonData.link}>{buttonData.title}</a> */}
          <div 
            className="left-banner mob" 
            // style={{display: "none", width: "100%", height: "100px", backgroundColor:"#000"}}
            onClick={() => {
              setOpenLeftBanner(!openLeftBanner);
              // console.log(buttonRef.current.offsetWidth);
            }}
            ref={buttonRef}
          >{buttonData.title}
            <a href={buttonData.link} target="_blank" rel="noreferrer">
              <div
                className="hide-banner mob"
                style={
                  openLeftBanner
                  ? { height: `${buttonRef.current.offsetWidth}px`, top: `${buttonRef.current.offsetHeight}px` }
                  : { height: '0', transitionDelay: '0.6s', top: '0' }
                }
              >
                <div
                  className="hide-banner__item"
                  style={
                    openLeftBanner
                    ? { transform: 'translateY(0%)' }
                    : { transform: 'translateY(-100%)' }
                  }
                >
                  <div className="hide-banner__content">
                    <img src={buttonData.picture && buttonData.picture[0]} alt="Крутое предложение" />
                  </div>
                </div>
              </div>
            </a>
            {/* <div 
              style={{ position: 'absolute' }} 
              onClick={() => {
                setOpenLeftBanner(!openLeftBanner);
              }}>
                <div>
                  <div className="banner__link-title">
                    <span>{leftBannerData.title}</span>
                  </div>
                </div>
                <div className="banner-button__left">
                  <div
                    className="banner-button__arrow"
                    style={
                      openLeftBanner
                      ? { transform: 'rotate(0deg)', transition: 'all 0.6s' }
                      : { transform: 'rotate(180deg)', transition: 'all 0.6s' }
                    }
                  >
                    <SvgArrow color="purple" direction="left" />
                </div>
              </div>
            </div> */}
          </div>
        </>
      )}
    </>
  );
}

export default MainSlider;
